import { environment } from '../environments/environment';

export const config = Object.freeze(environment);



// WEBPACK FOOTER //
// /home/runner/_work/monorepo/monorepo/admin-portal-old/src/app/app.config.ts